import * as React from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../CheckoutContextProvider/CheckoutContextProvider";
import styles from "./Summary.module.scss";
import genericStyles from "../../../lib/GenericStyles.module.scss";

interface ISummaryShippingOptionProps {
  goToShippingView: () => void;
}

const SummaryShippingOption: React.FC<ISummaryShippingOptionProps> = (props) => {
  const {t} = useTranslation();
  const {checkout} = useCheckoutContext();
  const {goToShippingView} = props;

  const shippingLine = checkout.cartData.positions.find((pos) => {
    return pos.type === "Shipping" && pos.isValid;
  });

  const OptionRow: React.FC = () => {
    if (!(shippingLine && shippingLine.reference)) {
      return <div className={genericStyles.errorBlockMain}>{t("checkout.noValidShippingOption")}</div>;
    }

    const {shippingClassId} = shippingLine.reference;
    const key = `shipping${shippingClassId || "option"}`;

    return (
      <div className="SimpleRadioList__Row">
        <label htmlFor={key}>
          <div className="SimpleRadioList__Row__Radio">
            <input type="radio" name="LogisticsTypeId" id={key} checked={true} readOnly={true} />
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: shippingLine.text,
            }}
          />
        </label>
      </div>
    );
  };

  return (
    <React.Fragment>
      <h2>{t("checkout.shippingOptions")}</h2>
      <span className={styles.pen} onClick={goToShippingView}>
        <span className="icon icon-pencil--blue icon-size--20">&#160;</span>
      </span>
      <div className={`SimpleRadioList${shippingLine && shippingLine.reference ? " ArrowBorder" : ""}`}>
        <OptionRow />
      </div>
    </React.Fragment>
  );
};

export default SummaryShippingOption;
